import { combineReducers } from 'redux'
import authorizationProviderReducer from '../../containers/AuthorizationProvider/AuthorizationProvider.reducer'
import headerSectionReducer from '../../containers/HeaderSection/HeaderSection.reducer'
import homeFormReducer from '../../containers/HomeForm/HomeForm.reducer'

export default combineReducers({
  headerSection: headerSectionReducer,
  authorizationProvider: authorizationProviderReducer,
  homeForm: homeFormReducer
})
